//Intrudction

import styled from 'styled-components'
import { useInView } from 'react-intersection-observer';
import girl from '../Images/door.jpeg';
import { show } from '../utils/utils';
import twitterSVG from '../Images/twitter.svg';
import openseaSVG from '../Images/opensea.svg';

const Introduction = styled.div`
    // border: 1px solid white;
    color: white;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
`

const ImageGirl = styled.img`
    width: 337px;
    height: 506px;
    border-radius: 22px;
    margin: 40px 106px 20px;
`

const Font = styled.div`
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 60px;
    text-align: center;
    letter-spacing: 0.02em;
    color: #FFFFFF;
    margin: 10rem 0 0 0;
`

const LogoGallery = styled.div`
    display: flex;
    flex-direction: row;
    margin: 4rem 0 0 0;
    align-items: center;
    justify-content: center;
`

const ImageLogo = styled.img`
width: 2rem;
height: 2rem;
margin: 0 3rem;
&:hover
{
    scale: 1.3;
}
`

export default function INTRODUCTION() {
    const { ref, inView } = useInView({ triggerOnce: false });

    return (

        <Introduction ref={ref} id='introduction' className={show(inView)}>

            <ImageGirl src={girl} alt="Girl" />
            <Font>
                HELLO, WHO WE ARE.
                <br />
                We are the first NFT that can be refunded.
                <br />
                Crypto Beliver. Came From China.
                <br />
                We started on 2022/02/24, and finished selling on 2022/04/11.
                <br />
                A total of 1024 NFT were sold at a price of 0.01 ETH.
                <br />
                
                <LogoGallery>
                    <a href="https://twitter.com/7DayReFundNFT">
                        <ImageLogo src={twitterSVG} alt="Twitter" />
                    </a>
                    <a href="https://opensea.io/collection/7daynft">
                        <ImageLogo src={openseaSVG} alt="OpenSea" />
                    </a>
                </LogoGallery>


            </Font>
        </Introduction>

    )
}